import { createApp } from 'vue';
import App from './App.vue';
import { createStore } from "vuex"; 
import router from './router'
import axios from "axios";

const store = createStore({
  state: {
    hasiDB: [],
    historyDB: [],
    tikSintetik: [],
    tikSintetik_B: [],
    madadimDB: [],
    count: 0,
    hist_count: 0,
    madadim_count: 0,
    per_name: '',
    period_ex: 12,
    tel: null,
  },
});
axios.defaults.withCredentials = true;
const app = createApp(App);
app.use(store).use(router);
app.mount('#app')